// covered-by: frontends/carrie/src/components/memory-citation/__tests__/MemoryCitationChip.test.tsx

import { Bookmark } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { SOURCE_BADGE_RADIUS_CLASS } from "../ask-puntt-sources/InlineSourceCitation";

/**
 * The chip's look, shared by the chip in the answer, its copy in the detail card
 * and its copy on the rail card, so the three read as one mark.
 *
 * The corner is the claim badge's (`SOURCE_BADGE_RADIUS_CLASS`): the chip sits
 * beside those badges and a different radius made it read as another kind of
 * control.
 */
export const MEMORY_CHIP_CLASS = `puntt-memory-chip inline-flex h-5 items-center justify-center gap-1 ${SOURCE_BADGE_RADIUS_CLASS} px-1.5 text-[11px] font-semibold leading-none`;

/** A chip that is only a label: it does not respond, so it does not look as if it would. */
export const MEMORY_CHIP_STATIC_CLASS = `${MEMORY_CHIP_CLASS} puntt-memory-chip--static`;

/** The bookmark and "M1". The number's wording is a catalog key, not a literal. */
export function MemoryChipFace({ number }: { number: number }) {
  const { t } = useTranslation("ui");
  return (
    <>
      <Bookmark size={10} weight="duotone" aria-hidden="true" />
      <span>{t("askPuntt.memoryCitation.number", { n: number })}</span>
    </>
  );
}

/** The chip as a non-interactive copy, for the detail card and the rail card. */
export function MemoryChipStatic({
  number,
  testId,
  className = "",
}: {
  number: number;
  testId?: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      data-testid={testId}
      className={`${MEMORY_CHIP_STATIC_CLASS} ${className}`.trim()}
    >
      <MemoryChipFace number={number} />
    </span>
  );
}
